<div class="row">
  <div class="col">
    <div class="box box-primary">

      <div class="box-header text-center">
        <h3 class="box-title ">Emitir OS Preventiva</h3><br />
      </div>

      <div class="divider"></div>

      <div class="box-body h470">
        <form novalidate>

          <div class="form-row">

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="id">Próxima execução inicial</label>
                <input class="form-control parametro" type="date" id="dataInicial" #dataInicial max="2999-12-31" [ngClass]="{'h-error' : validacaoDatas != ''}"
                  (change)="validaDatas(dataInicial.value, dataFinal.value)">
              </div>
            </div>

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="requisitante">Próxima execução final</label>
                <input class="form-control parametro" type="date"  id="dataFinal" #dataFinal max="2999-12-31" [ngClass]="{'h-error' : validacaoDatas != ''}"
                  (change)="validaDatas(dataInicial.value, dataFinal.value)">
                <span *ngIf="validacaoDatas!=''" class="text-danger">{{this.validacaoDatas}}</span>
              </div>
            </div>

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="areaTecnicaId">Área técnica</label>
                <select class="form-control parametro" id="areaTecnicaId" #areaTecnicaId [ngClass]="{'h-error' : validacaoAreaTecnica != ''}"
                  (change)="validaAreaTecnica(areaTecnicaId.value)">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let t of areasTecnicas" [value]="t.id">{{ t.nome }}</option>
                </select>
                <span *ngIf="validacaoAreaTecnica!=''" class="text-danger">{{this.validacaoAreaTecnica}}</span>
              </div>
            </div>


            <div class="col-md-2">
              <button type="submit" class="btn btn-primary btn-block btn-bottom btn-shadow" (click)="buscar(
                { 
                  'areaTecnicaId' : areaTecnicaId.value, 
                  'dataInicial' : dataInicial.value,
                  'dataFinal' : dataFinal.value
                })">
                <i class="fa fa-search"></i></button>
            </div>

            <div class="col-md-1">
              <button type="submit" class="btn btn-light btn-block btn-bottom btn-shadow" (click)="clearParametros()"><i
                  class="fa fa-trash"></i></button>
            </div>

          </div>

        </form>


        <section *ngIf="this.resultadosPesquisa?.length > 0" class="animated fadeInDown">

          <div class="box box-primary">

            <div class="box-header">
              <div class="row">
                <div class="col-md-6">
                  <div class="justify-content-start">
                    <h3 class="box-title ">Resultado da Pesquisa</h3><br />
                    <span class="text-muted">Clique nas linhas que deseja selecionar</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex justify-content-end">
                    Selecionar: <span class="cp pl-2 pr-2 text-primary" (click)="selecionarTodos()">Todos</span>/<span
                      class="cp pl-2 pr-1 text-primary" (click)="selecionarNenhum()">Nenhum</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="box-body">

              <div style="border: 2px solid #d2d6de; padding: 6px; min-height: 220px; max-height: 220px;"
                class="pre-scrollable">
                <table class="mb-0 table table-hover table-bordered">
                  <thead class="thead-default">
                    <tr>
                      <th>Classe Equipamento</th>
                      <th>Tipo Equipamento</th>
                      <th>Código</th>
                      <th>Descricao</th>
                      <th>Rotina</th>
                      <th class="wf90">Periodicidade</th>
                      <th class="wf180">Próxima Execução</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr  class="cp" *ngFor="let rp of this.resultadosPesquisa" [ngClass]="{'tr-info': rp.marcado}"
                      (click)="selecionarRotinaEquipamento(rp?.atividadeId)">
                      <td>{{ rp?.classeEquipamento }}</td>
                      <td>{{ rp?.tipoEquipamento }}</td>
                      <td>{{ rp?.codigo }}</td>
                      <td>{{ rp?.equipamentoNome }}</td>
                      <td>{{ rp?.rotinaDescricao }}</td>
                      <td class="text-center">{{ rp?.espacamento }}</td>
                      <td class="text-center">{{ rp?.proximaExecucao | date:'dd/MM/yyyy'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

            <div class="box-footer">
              <section class="footer" *ngIf="this.resultadosPesquisa !== undefined && this.resultadosPesquisa?.length > 0" >
              <div class="footer-total">Total pesquisados :
                <b>{{ this.resultadosPesquisa?.length  }}</b>
              </div>

              <div class="footer-selecionados">
                Total selecionados: <b>{{this.totalOSsAGerar}}</b>
              </div>
            </section>

            </div>
          </div>
        </section>

        <section *ngIf="this.resultadosPesquisa?.length ==  0 && nenhumResultado == true"
          class="animated fadeInDown text-center h300" style="margin-top:70px;">

          <div class="row">
            <div class="col-md-12">
              <img src="./assets/images/no-result2.png">
            </div>
            <div class="col-md-12">
              <h6>Nenhum resultado foi encontrado</h6>
            </div>
            <div class="col-md-12">
              <h6>com os parâmetros fornecidos</h6>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">

          <form novalidate  [formGroup]="form" id="form"
          (validSubmit)="gerarOSs()">

          <div class="form-row">

            <div class="col-md-4" *ngIf="this.empreiteiras.length > 1">
              <div class="position-relative form-group">
                <label for="">Empreiteira</label>
                <select class="form-control" #empreiteiraId formControlName="empreiteiraId" required
                  (change)="getEngenheirosEEncarregadosPorEmpreiteira(empreiteiraId.value)">
                  <option value="">selecione</option>
                  <option *ngFor="let e of this.empreiteiras" value="{{ e.id }}">{{ e.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Engenheiro responsável</label>
                <select class="form-control" formControlName="engenheiroResponsavelId" required>
                  <option value="" *ngIf='this.engenheiros.length > 1'>selecione</option>
                  <option *ngFor="let e of this.engenheiros" value="{{ e.id }}">{{ e.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="">Responsável OS</label>
                <select class="form-control" formControlName="encarregadoResponsavelId" required>
                  <option value="">selecione</option>
                  <option *ngFor="let e of this.encarregados" value="{{ e.id }}">{{ e.nome }}</option>
                </select>
              </div>
            </div>

          </div>

        </form>


      </div>
    </div>
  </div>
</div>


<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <app-ball-pulse *ngIf="this.isProcessing"></app-ball-pulse>
          </div>

          <div class="col-md-2">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
         
          <div class="col-md-3 text-right pr-3 mt-2">
            <div class="custom-checkbox custom-control">
              <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px;" [checked]="false"
                #imprimirEvidenciaDeFotos>
              <label class="form-check-label" for=""> Imprime a evidência de fotos? </label>
            </div>
          </div>
          <div class="col-md-2 text-right pr-3 mt-2">
            <div class="custom-checkbox custom-control">
              <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px;" checked
                #obterosmanual>
              <label class="form-check-label" for=""> Obter OS Manual </label>
            </div>
          </div>
      
          <div class="col-md-2">
            <div class="d-flex justify-content-end">
              <button class="btn btn-lg btn-primary btn-shadow btn-block" 
              type="submit" 
              form="form"
                [disabled]="(this.totalOSsAGerar == 0 || this.isProcessing) || !this.autorizacoes?.podeIncluir || this.isProcessing">
                <i class="fa fa fa-print pt-1 pull-left"></i>Gerar OS
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


